<template>
  <div>
    <desktop-pay v-if="payProps.visible" :lang-id-data="$store.state.locale.langIdData" :store-lang="$store.state.locale.locale" :desk-pay="payProps" @close="closePayModal" />
    <mobile-pay />
  </div>
</template>

<script>
import DesktopPay from '~/components/pay/deskPayModal.vue'
import MobilePay from '~/site/components/orderModal/index.vue'
import { DeviceEnum } from '~/enums/deviceEnum'
import Bus from '~/site/model/bus';
import { QueryKey } from '~/enums/tanstack'
import { queryCache } from '~/utils/queryCache'

export default {
  components: {
    DesktopPay,
    MobilePay
  },
  data() {
    return {
      DeviceEnum,
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: null,
        orderCode: null
      }
    }
  },
  computed: {
    isDesktopPay() {
      return this.$store.state.site?.orderModal?.device === DeviceEnum.DESKTOP
    },
    payProps() {
      return {
        visible: this.$store.state.site?.orderModal?.visible && this.isDesktopPay,
        isGoPay: true,
        payUrl: this.$store.state.site?.orderModal?.payUrl,
        orderCode: this.$store.state.site?.orderModal?.order
      }
    }
  },
  methods: {
    closePayModal() {
      this.$store.commit('site/CLOSE_ORDER_MODAL')
      queryCache.removeQueries([QueryKey.projectVipInfo])
      Bus.$emit('reloadActivity')
    }
  }
}
</script>

<style lang="less" scoped />